import { DocumentItem, SearchResult, SesamMessage, ViewerDocument } from './types';
import { getDecodedToken, getStoredToken, redirectToLogin } from '../../../utils/auth';

export function formatDate(value?: string) {
  if (!value) {
    return 'Noch nicht synchronisiert';
  }

  return new Intl.DateTimeFormat('de-DE', {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(new Date(value));
}

export function formatDateOnly(value?: string) {
  if (!value) {
    return 'Kein Datum';
  }

  return new Intl.DateTimeFormat('de-DE', {
    dateStyle: 'medium'
  }).format(new Date(value));
}

export function authHeaders(contentType?: string) {
  if (!getDecodedToken()) {
    redirectToLogin();
    throw new Error('Bitte erneut anmelden.');
  }

  const token = getStoredToken();
  const headers: Record<string, string> = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  return headers;
}

export function createMessageId(prefix: string) {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function formatDocumentName(name?: string) {
  return (name || '').replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
}

export function resolveSelectedDocument(
  documents: DocumentItem[],
  messages: SesamMessage[],
  selectedDocumentId?: number
): ViewerDocument | undefined {
  const selectedDocument = documents.find((document) => document.id === selectedDocumentId);

  if (selectedDocument) {
    return selectedDocument;
  }

  const selectedSource = messages
    .flatMap((message) => message.sources || [])
    .find((source) => source.document_id === selectedDocumentId);

  return selectedSource ? sourceToViewerDocument(selectedSource) : undefined;
}

function sourceToViewerDocument(source: SearchResult): ViewerDocument {
  return {
    id: source.document_id,
    project_title: source.project_title,
    folder_path: source.folder_path,
    page_number: source.page_number,
    slide_number: source.slide_number,
    slide_id: source.slide_id,
    name: source.name,
    web_url: source.web_url,
    mime_type: source.mime_type,
    created_at: source.created_at,
    last_modified_at: source.last_modified_at
  };
}
